/* 
** PAGELOAD: var tooltips = new toolTips();
**** tooltips.init();
*/
var toolTips = function () { 	
	var init = function(){
		var theTips = document.querySelectorAll(".tooltipTrigger");
		for(var i = 0; i < theTips.length; i++){
			theTips[i].removeEventListener("click", toggleTip);
			theTips[i].addEventListener("click", toggleTip);
			theTips[i].removeEventListener("blur", closeTip);
			theTips[i].addEventListener("blur", closeTip);
		}
	},
	toggleTip = function(e){
		e.preventDefault();
		var el = e.currentTarget;
		if(el.nextElementSibling.className == "visible"){
			hideTip(el);
		}else {
			showTip(el);
		}
	},
	hideTip = function(elem){
		document.removeEventListener('click', hideOnClickOutside);
		document.removeEventListener('touchstart', hideOnClickOutside);
		document.removeEventListener("keyup", escapeTip);
		elem.classList.remove("activeTip");
		elem.nextElementSibling.classList.remove("visible");
		elem.nextElementSibling.setAttribute("aria-hidden", "true"); 
	},  
	showTip = function(elem){
		elem.classList.add("activeTip");
		elem.nextElementSibling.classList.add("visible");
		elem.nextElementSibling.setAttribute("aria-hidden", "false");
		document.addEventListener('click', hideOnClickOutside);
		document.addEventListener('touchstart', hideOnClickOutside);
		document.addEventListener("keyup", escapeTip);
	},
	
	hideOnClickOutside = function(e){
		var elem = document.querySelector(".activeTip");
		if (!elem.contains(e.target)) {
			hideTip(elem);
		}
	},
	escapeTip = function(e){
		var elem = document.querySelector(".activeTip");
		if((e.which || e.keyCode) === 27){ 
			hideTip(elem);
    		}
	},
	
	closeTip = function(e){ // TODO combine this with hideTip function
		var el = e.currentTarget;
		document.removeEventListener('click', hideOnClickOutside);
		document.removeEventListener('touchstart', hideOnClickOutside);
		document.removeEventListener("keyup", escapeTip);
		el.classList.remove("activeTip");
		el.nextElementSibling.classList.remove("visible");
		el.nextElementSibling.setAttribute("aria-hidden", "true"); 
	};
	return {
		init: init
	};
};

// removing this focus & mousedown event due to accessibility audit from siteimprove
/* el.addEventListener("mousedown", function(e){
	toggleTip(el);
	// must keep e.preventDefault here to prevent the focus event from firing
	// using mousedown event so that we can only fire the toggle function once
	// click would fire the click event plus the focus event
	e.preventDefault(); 
});
el.addEventListener("focus", function(e){
	showTip(el);
	document.addEventListener("keyup", escapeTip);
});*/